<h3 mat-dialog-title>Vessel redundancy WCFDI</h3>

<mat-dialog-content>

    <form name="myForm" class="example-form">
        <mat-form-field class="example-full-width">
            <mat-label>Name</mat-label>
            <input matInput type="text" name="vesselWcfdiName" [(ngModel)]="redundancyWcfdi.name">
        </mat-form-field>

        <mat-form-field class="example-full-width">
            <mat-label>Description</mat-label>
            <textarea matInput type="text" name="Description" [(ngModel)]="redundancyWcfdi.description"></textarea>
        </mat-form-field>
    </form>

</mat-dialog-content>

<mat-dialog-actions>
    <button mat-icon-button matTooltip="delete" (click)="onDeleteClick()">
        <mat-icon>delete_outline</mat-icon>
    </button>

    <span class="example-spacer"></span>

    <button mat-button (click)="onCancelClick()">Cancel</button>

    <button mat-button extended (click)="onUpdateClick()" [mat-dialog-close]="redundancyWcfdi" cdkFocusInitial>
        Update
    </button>
</mat-dialog-actions>